import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import Body from "features/shared/styles/typography/Body.styled";
import { Summary } from "features/shared/styles/typography/Summary.styled";

import ConsentBanner from "./styles/ConsentBanner.styled";
import ConsentBannerContent from "./styles/ConsentBannerContent.styled";

const CallToActionBanner = () => {
  const images = LocalImages.shared.images;
  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.consent });
  const subtitle = text("cta-banner.subtitle");
  return (
    <ConsentBanner>
      <img
        className="cta-icon"
        src={images.icons.consentBannerIcon}
        alt="consent banner icon"
      />
      <ConsentBannerContent>
        <Summary>{text("cta-banner.title")}</Summary>
        {subtitle !== "" ? <Body>{subtitle}</Body> : null}
      </ConsentBannerContent>
    </ConsentBanner>
  );
};

export default CallToActionBanner;
